import { createPingMessage } from "protocol";
import { send } from "./websocket-client";

const PING_INTERVAL_MS = 5000;

let intervalId: number | null = null;

export function startPinging(onPingSent: () => void): void {
  if (intervalId !== null) {
    return;
  }

  intervalId = window.setInterval(() => {
    send(createPingMessage());
    onPingSent();
  }, PING_INTERVAL_MS);
}

export function stopPinging(): void {
  if (intervalId !== null) {
    window.clearInterval(intervalId);
    intervalId = null;
  }
}
